// extracted by mini-css-extract-plugin
export default {"forumLayout":"QSvlqeSe_iIcUODnvAcN"};